import script from "./AddNewOneDialog-IPROXY.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewOneDialog-IPROXY.vue?vue&type=script&setup=true&lang=js"

import "./AddNewOneDialog-IPROXY.vue?vue&type=style&index=0&id=c1ead164&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ead164"]])

export default __exports__